import axios from 'axios';
import { URL } from '../utils/constants';

export class API {
    static get_category () {
        const URL_API = `${URL}/api/v1/category`;

        return axios.get(URL_API);
    }

    static get_stories (newUrl, getParam) {
        let URL_API = newUrl ? URL+newUrl : `${URL}/api/v1/appeal`;

        if (getParam) {
            //console.log("getParam-------", getParam);
            URL_API += `?${getParam}`;
        }

        return axios.get(URL_API);
    }

    static get_story (id) {
        const URL_API = `${URL}/api/v1/appeal/${id}`;
        return axios.get(URL_API);
    }

    static post_story (data) {

        /*
        title:       '',
        body:        '',
        category:    '',
        email:       '',
        rulesAgreed: false,
        */
        const URL_API = `${URL}/api/v1/appeal`;

        return axios.post(URL_API, data);
    }

    static like_story (idStory, data) {
        const URL_API = `${URL}/api/v1/appeal/${idStory}/like`;

        return axios.post(URL_API);
    }

    static dislike_story (idStory, data) {
        const URL_API = `${URL}/api/v1/appeal/${idStory}/dislike`;

        return axios.delete(URL_API);
    }
}
